var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignupRestra(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 174,
    height: 131,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M.024 131.068H200v25.108H.024z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.275 127c-17.87-9.124-19.038-53.366 15.522-63.721C62.356 52.924 55.954 26.793 85.028 7.26c26.503-17.805 70.347-2.713 84.95 43.591 10.414 33.017-1.737 74.434-10.028 76.148H12.275",
    fill: "#F8EFDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.037 104.702h37.27V70.274h-37.27zM109.268 104.702h37.803V70.274h-37.803z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.942 106.412h43.122V68.564h-43.122v37.848zm-78.719 0h43.122V68.564H27.223v37.848zM21.59 20.756V123.09h55.103V68.564h22.901v54.527h55.103V20.756H21.59z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5A87A8",
    d: "M21.59 125.948h55.103v-5.816H21.59zM99.952 125.948h54.745v-5.816H99.952z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m154.697 27.068-.484-1.696H21.787l-.197.69V70.26c3.94-.727 6.928-4.174 6.928-8.323a8.45 8.45 0 0 0 3.206 6.628h10.528a8.45 8.45 0 0 0 3.206-6.628 8.45 8.45 0 0 0 3.207 6.628h10.528a8.45 8.45 0 0 0 3.207-6.628 8.45 8.45 0 0 0 3.206 6.628h4.739v1.816c.174.01.347.026.524.026a8.473 8.473 0 0 0 8.473-8.47 8.451 8.451 0 0 0 3.205 6.628h10.527a8.448 8.448 0 0 0 3.208-6.628h.378a8.47 8.47 0 0 0 9.282 8.429v-1.8h4.452a8.448 8.448 0 0 0 3.208-6.63 8.45 8.45 0 0 0 3.205 6.63h10.527a8.449 8.449 0 0 0 3.208-6.63 8.449 8.449 0 0 0 3.206 6.63h10.527a8.45 8.45 0 0 0 3.207-6.63c0 4.25 3.133 7.76 7.215 8.368V27.068",
    fill: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.577 104.702h39.494V70.274h-39.494v34.428zm38.816-36.349h-38.137a2.6 2.6 0 0 0-2.6 2.599v33.072a2.6 2.6 0 0 0 2.6 2.6h38.137a2.6 2.6 0 0 0 2.599-2.6V70.952a2.599 2.599 0 0 0-2.6-2.599z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.942 105.412h41.122V69.564h-41.122v35.848zm40.072-37.848h-39.022a3.05 3.05 0 0 0-3.05 3.05v33.748a3.05 3.05 0 0 0 3.05 3.05h39.022a3.05 3.05 0 0 0 3.05-3.05V70.614a3.05 3.05 0 0 0-3.05-3.05z",
    fill: "#1C1C1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.037 104.702h39.494V70.274H29.037v34.428zm38.815-36.349H29.715a2.6 2.6 0 0 0-2.599 2.599v33.072a2.6 2.6 0 0 0 2.6 2.6h38.136a2.6 2.6 0 0 0 2.6-2.6V70.952a2.599 2.599 0 0 0-2.6-2.599z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.223 105.412h41.122V69.564H28.223v35.848zm40.415-37.848H28.93a2.706 2.706 0 0 0-2.707 2.706v34.436a2.706 2.706 0 0 0 2.707 2.706h39.708a2.707 2.707 0 0 0 2.707-2.706V70.27a2.706 2.706 0 0 0-2.707-2.706z",
    fill: "#1C1C1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.046 65.206a8.472 8.472 0 0 0 8.472-8.47H11.576a8.472 8.472 0 0 0 8.47 8.47",
    fill: "#F9821B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.988 65.206a8.47 8.47 0 0 0 8.47-8.47h-16.94a8.47 8.47 0 0 0 8.47 8.47M70.869 65.206a8.473 8.473 0 0 0 8.473-8.47H62.4a8.47 8.47 0 0 0 8.469 8.47",
    fill: "#F06F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.81 65.206a8.472 8.472 0 0 0 8.472-8.47h-16.94c0 4.676 3.79 8.47 8.468 8.47M53.93 65.206a8.471 8.471 0 0 0 8.47-8.47H45.458a8.471 8.471 0 0 0 8.471 8.47M147.482 56.736a8.47 8.47 0 0 0 8.47 8.47 8.47 8.47 0 0 0 8.472-8.47h-16.942",
    fill: "#F9821B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.011 65.206a8.472 8.472 0 0 0 8.471-8.47h-16.94a8.47 8.47 0 0 0 8.47 8.47M105.13 65.206a8.472 8.472 0 0 0 8.472-8.47H96.66a8.47 8.47 0 0 0 8.47 8.47",
    fill: "#F06F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.07 65.206a8.473 8.473 0 0 0 8.472-8.47h-16.94a8.47 8.47 0 0 0 8.468 8.47",
    fill: "#F9821B"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M154.213 20.171H21.787L11.348 56.736h153.304l-10.44-36.565"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6F6F6F",
    d: "M16.043 130.37h143.914v-10.612H16.043z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B0B0B0",
    d: "M16.043 130.37h143.914v-2.302H16.043zM16.043 120.97h143.914v-1.212H16.043z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F06F00",
    d: "M28.966 55.936h16.47l4.435-36.565H35.09l-6.123 36.565"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9821B",
    d: "M94.084 19.371h-12.3l-2.028 36.565h16.356L94.084 19.37M65.77 19.371H50.678l-4.435 36.565h15.801L65.77 19.37M147.714 55.936h16.938l-10.44-36.565H141.59l6.124 36.565"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F06F00",
    d: "M80.982 19.371H66.574l-3.726 36.565h16.107l2.027-36.565"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9821B",
    d: "M34.277 19.371h-12.49L11.348 55.936h16.806l6.123-36.565"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F06F00",
    d: "M140.779 19.371h-14.783l4.435 36.565h16.47L140.78 19.37M109.294 19.371H94.885l2.027 36.565h16.107l-3.725-36.565"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9821B",
    d: "M125.19 19.371h-15.092l3.726 36.565h15.8L125.19 19.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.623 119.758H66.308v-12.346h2.33a2.707 2.707 0 0 0 2.707-2.706V70.393a8.44 8.44 0 0 0 5.278-2.24v51.605",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.345 70.393v-.123a2.706 2.706 0 0 0-2.707-2.706h-2.33v-3.34l10.315 3.728v.2a8.44 8.44 0 0 1-5.278 2.24",
    fill: "#D8E0E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.308 104.702h2.223V70.274h-2.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCFCFC",
    d: "M69.345 105.412h-3.037v-.71h2.223V70.274h-2.223v-.71h3.037v35.848"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.638 107.412h-2.33v-2h3.037V69.564h-3.037v-2h2.33a2.706 2.706 0 0 1 2.707 2.706v34.436a2.707 2.707 0 0 1-2.707 2.706",
    fill: "#777"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFACAC",
    d: "M66.308 122.69h10.315v-1.72H66.308z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E1A6A7",
    d: "M66.308 120.97h10.315v-1.212H66.308z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.268 119.758H99.6V68.352a8.43 8.43 0 0 0 5.35 2.052c-.005.07-.008.14-.008.21v33.748a3.05 3.05 0 0 0 3.05 3.05h1.276v12.346",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.95 70.404a8.43 8.43 0 0 1-5.35-2.052v-.4l9.668-3.727v3.34h-1.276a3.05 3.05 0 0 0-3.042 2.839",
    fill: "#D8E0E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.577 104.702h1.691V70.274h-1.69z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCFCFC",
    d: "M109.268 105.412h-2.326V69.564h2.326v.71h-1.69v34.428h1.69v.71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.268 107.412h-1.276a3.05 3.05 0 0 1-3.05-3.05V70.614a3.05 3.05 0 0 1 3.05-3.05h1.276v2h-2.326v35.848h2.326v2",
    fill: "#777"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFACAC",
    d: "M99.6 122.69h9.668v-1.72H99.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E1A6A7",
    d: "M99.6 120.97h9.668v-1.212H99.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.837 121.49V95.984l7.256.767v24.74h-7.256zm7.256-52.764v26.012l-7.256-.767V66.104l7.256 2.622zm-8.856-4.901v59.266h10.456V67.603l-10.456-3.778zM107.856 121.49V95.984l-7.256.767v24.74h7.256zM100.6 68.727v26.012l7.256-.767V66.104l-7.256 2.622zm8.856-4.901v59.266H99V67.603l10.456-3.778z",
    fill: "#535353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.13 121.382V96.641l7.256-.767v25.508h-7.256zm7.256-55.387v27.867l-7.256.768V68.617l7.256-2.622zm-8.856 1.499v55.488h10.456V63.716L99.53 67.494zm1.6 53.888V96.641l7.256-.767v25.508h-7.256zm7.256-55.387v27.867l-7.256.768V68.617l7.256-2.622zm-8.856 1.499v55.488h10.456V63.716L99.53 67.494z",
    fill: "#779FBD"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M71.065 127.654h34.593v-3.412H71.065z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.167 114.087a.2.2 0 0 1-.2.2H21.79a.2.2 0 0 1-.2-.2v-2.335c0-.111.09-.2.2-.2h6.177c.11 0 .2.089.2.2v2.335",
    fill: "#F3B36C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.89 117.942a.2.2 0 0 1-.2.201h-6.176a.2.2 0 0 1-.2-.2v-2.336c0-.11.09-.2.2-.2h6.176c.111 0 .2.09.2.2v2.335",
    fill: "#F9821B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.077 111.07a.2.2 0 0 1-.2.2H32.7a.2.2 0 0 1-.2-.2v-2.336c0-.11.09-.2.2-.2h6.177c.11 0 .2.09.2.2v2.336M148.12 115.877c0-.11.089-.2.2-.2h6.176a.2.2 0 0 1 .2.2v2.336a.2.2 0 0 1-.2.2h-6.176a.2.2 0 0 1-.2-.2v-2.336",
    fill: "#F3B36C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.396 112.022c0-.111.09-.201.2-.201h6.177c.11 0 .2.09.2.2v2.336a.2.2 0 0 1-.2.2h-6.177a.2.2 0 0 1-.2-.2v-2.335",
    fill: "#F9821B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.12 108.166c0-.11.089-.2.2-.2h6.176a.2.2 0 0 1 .2.2v2.336a.2.2 0 0 1-.2.2h-6.176a.2.2 0 0 1-.2-.2v-2.336",
    fill: "#F3B36C"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505961",
    d: "M76.693 123.09h22.901V68.565h-22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.199 90.792a.46.46 0 0 1-.412-.244l-2.628-5.054-2.63 5.054a.469.469 0 0 1-.617.197.434.434 0 0 1-.205-.593l3.04-5.843c.156-.3.666-.3.821 0l3.04 5.843a.433.433 0 0 1-.205.593.459.459 0 0 1-.204.047",
    fill: "#C5C5C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.653 99.926h23.01v-8.594h-23.01v8.594zm23.18.92h-23.35a.75.75 0 0 1-.749-.75v-8.935c0-.413.336-.748.748-.748h23.351c.413 0 .749.335.749.748v8.936a.75.75 0 0 1-.749.748z",
    fill: "#5A87A8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M97.173 100.268h23.815V90.253H97.173z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.653 99.526h23.01v-8.594h-23.01v8.594zm23.18.92h-23.35a.75.75 0 0 1-.749-.75v-8.935c0-.413.336-.748.748-.748h23.351c.413 0 .749.335.749.748v8.936a.75.75 0 0 1-.749.748z",
    fill: "#F06F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.676 84.524a1.52 1.52 0 1 1-1.518-1.52c.84-.001 1.518.68 1.518 1.52",
    fill: "#ADADAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.94 96.894c-.585 0-1.099-.778-1.099-1.665s.514-1.665 1.099-1.665 1.1.778 1.1 1.665-.515 1.665-1.1 1.665zm0-4.185c-1.15 0-2.05 1.107-2.05 2.52s.9 2.521 2.05 2.521 2.05-1.108 2.05-2.521c0-1.413-.9-2.52-2.05-2.52zM105.623 94.891v-1.344c1.442.081 2.198.513 2.198.672 0 .16-.756.591-2.198.672zm-.476-2.214c-.263 0-.475.191-.475.428v4.25c0 .235.212.426.475.426s.476-.191.476-.427v-1.606c1.632-.084 3.149-.606 3.149-1.529 0-1.012-1.824-1.542-3.625-1.542zM117.952 92.709c-.263 0-.477.191-.477.427v2.855l-2.47-3.104a.505.505 0 0 0-.532-.157.433.433 0 0 0-.331.406v4.186c0 .237.213.428.476.428s.475-.191.475-.428v-2.855l2.472 3.104a.49.49 0 0 0 .387.179.466.466 0 0 0 .144-.022.432.432 0 0 0 .33-.406v-4.186c0-.236-.213-.427-.474-.427M113.146 96.894h-2.812v-1.237h2.674c.263 0 .475-.192.475-.428s-.212-.427-.475-.427h-2.674v-1.238h2.674c.263 0 .475-.192.475-.428s-.212-.427-.475-.427h-3.148c-.263 0-.476.191-.476.427v4.186c0 .237.213.428.476.428h3.286c.263 0 .476-.191.476-.428 0-.235-.213-.428-.476-.428",
    fill: "#676767"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9F9",
    d: "M67.456 130.573h41.812v-3.411H67.456z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignupRestra);
export default __webpack_public_path__ + "static/media/signup-restra.323414a5e48304619a88a2eb82f88171.svg";
export { ForwardRef as ReactComponent };